meedy.factory('meedy.vacationModel', ['$rootScope', 'applicationModel', 'meedy.baseModel', 'meedy.vacationService',
    function ($rootScope, applicationModel, baseModel, vacationService) {

        function VacationModel() {

            this.getUserVacations = function () {
                vacationService.getUserVacations().then(
                    function (resources) {
                        $rootScope.$broadcast(Event.MEEDY.VACATION.GET_USER_VACATIONS.SUCCESS, resources);
                    },
                    function (error) {
                        $rootScope.$broadcast(Event.MEEDY.VACATION.GET_USER_VACATIONS.ERROR, error);
                    }
                )
            };

            this.createUserVacation = function (vacation) {
                applicationModel.actionInProgress = true;
                vacationService.createUserVacation(vacation).then(
                    function (resources) {
                        $rootScope.$broadcast(Event.MEEDY.VACATION.CREATE_USER_VACATION.SUCCESS, resources);
                        applicationModel.actionInProgress = false;
                    },
                    function (error) {
                        $rootScope.$broadcast(Event.MEEDY.VACATION.CREATE_USER_VACATION.ERROR, error);
                        applicationModel.actionInProgress = false;
                    }
                )
            };

            this.deleteVacation = function (idVacation) {
                applicationModel.actionInProgress = true;
                vacationService.deleteVacation(idVacation).then(
                    function (resources) {
                        $rootScope.$broadcast(Event.MEEDY.VACATION.DELETE_VACATION.SUCCESS, resources);
                        applicationModel.actionInProgress = false;
                    },
                    function (error) {
                        $rootScope.$broadcast(Event.MEEDY.VACATION.DELETE_VACATION.ERROR, error);
                        applicationModel.actionInProgress = false;
                    }
                )
            };

            this.checkCollisions = function(availabilityRule) {
                applicationModel.actionInProgress = true;
                vacationService.checkCollisions(availabilityRule).then(
                    function (list) {
                        $rootScope.$broadcast(Event.MEEDY.VACATION.CHECK_COLLISIONS.SUCCESS, list);
                        applicationModel.actionInProgress = false;
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.MEEDY.VACATION.CHECK_COLLISIONS.ERROR, error);
                        applicationModel.actionInProgress = false;
                    }
                )
            };
        }

        return new VacationModel();
    }
]);
